export {};
//# sourceMappingURL=amplitude.js.map